import React from 'react';
import { Route, Routes } from 'react-router-dom';

import UpdatesPage from './UpdatesPage';

const UpdatesRoutes: React.FC = () => (
  <Routes>
    <Route path="/" element={<UpdatesPage />} />
  </Routes>
);

export default UpdatesRoutes;
